import React from "react";
import { Link } from "react-router-dom";
import { isExternalURL } from "../../helpers/UrlHelpers";

interface PropsInterface {
  link?: string | undefined;
  children: React.ReactNode;
  className?: string;
}

const OptionalLink = (props: PropsInterface) => {
  if (!props.link) {
    return (
      <>
        {props.children}
      </>
    );
  }

  if (isExternalURL(props.link)) {
    return (
      <a href={props.link} className={`v-link2 ${props.className}`}>
        {props.children}
      </a>
    )
  }

  return (
    <Link to={props.link} relative='route' className={`v-link2 ${props.className}`}>
      {props.children}
    </Link>
  )
}

export default OptionalLink;
